<canvas id="candlestickCanvas" [width]="width()" [height]="height()"></canvas>
